import {ApiBase} from "@/src/model/ApiBase";
import {CELONIS_CONTENT_API_TYPE} from "@/src/model/apiTypes";

export class StudioApi extends ApiBase {
    async [CELONIS_CONTENT_API_TYPE.GET_STUDIO_SPACES]() {
        return await this.httpGet(`emsspaces/`)
    }

    async [CELONIS_CONTENT_API_TYPE.GET_STUDIO_SPACES_PACKAGES]({emsSpaceId}) {
        return await this.httpGet(`emsspaces/${emsSpaceId}/packages/`)
    }

    async [CELONIS_CONTENT_API_TYPE.POST_PACKAGE_SPACE]({emsSpaceId, graphId, pushAllCheckIds}) {
        if (pushAllCheckIds) {
            return await this.httpPost(`emsspaces/${emsSpaceId}/graph/${graphId}/url/True/`, {})
        } else {
            return await this.httpPost(`emsspaces/${emsSpaceId}/graph/${graphId}/url/False/`, {})
        }
    }

    async [CELONIS_CONTENT_API_TYPE.GET_SPACE_URL]({emsSpaceId, pushAllCheckIds, graphId, workspaceId}) {
        if (pushAllCheckIds) {
            return await this.httpGet(`emsspaces/${emsSpaceId}/graph/${graphId}/url/True`)
        } else {
            return await this.httpGet(`emsspaces/${emsSpaceId}/graph/${graphId}/url/False`)
        }
    }

    async [CELONIS_CONTENT_API_TYPE.GET_EMS_URL]() {
        return await this.httpGet(`emsurl/`)
    }

    async [CELONIS_CONTENT_API_TYPE.GET_CELONIS_API]() {
        return await this.httpGet(`celonis_api/`)
    }

    async [CELONIS_CONTENT_API_TYPE.UPDATE_CELONIS_API](apiKey) {
        return await this.httpPatch(`celonis_api/`, {apiKey})
    }
}